// extracted by mini-css-extract-plugin
export default {"control":"OrderControl_control__VrqRK","button":"OrderControl_button__IfhhU"};